import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Button, Buttons, MessageType } from 'src/app/common/messagePopupModel';

@Component({
  selector: 'app-message-alert-popup',
  templateUrl: './message-alert-popup.component.html',
  styleUrls: ['./message-alert-popup.component.css']
})
export class MessageAlertPopupComponent {
  title = '';
  message = '';
  type: MessageType;
  buttons: Buttons = Buttons.Okay

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    (this.title = data.title),
      (this.message = data.message),
      (this.type = data.type);
    this.buttons = data.buttons;
  }

  dialogResultSubject = new Subject<Button>();
  dialogResult$ = this.dialogResultSubject.asObservable();

  public get Buttons(): typeof Buttons {
    return Buttons;
  }

  public get Button(): typeof Button {
    return Button;
  }

  public get MessageType(): typeof MessageType {
    return MessageType;
  }

  click(button: Button) {
    this.dialogResultSubject.next(button);
  }
}
